import { useState, useCallback, useEffect } from "react";

const DICT = {
  fr: {
    // Layout
    "layout.subtitle": "Réservation de séjour",
    "lang.fr": "FR",
    "lang.en": "EN",
    "lang.aria": "Choisir la langue",
    // Common
    "common.loading": "Chargement…",
    "common.total": "Montant total",
    "common.reservationNo": "N° de réservation",
    "common.backToTrips": "Retour aux séjours",
    "common.seeTrips": "Voir les séjours",
    // Payments
    "pay.cb_1x": "Carte bancaire (1x)",
    "pay.cb_3x": "Carte bancaire (3x)",
    "pay.cheque": "Chèque",
    "pay.cheque_1x": "Chèque 1x",
    "pay.cheque_nx": "Chèque plusieurs fois",
    "pay.virement": "Virement",
    "pay.cheque_vacances": "Chèques Vacances",
    // BookingList
    "list.title": "Nos séjours à thème",
    "list.subtitle": "Choisissez votre séjour et réservez en quelques clics.",
    "list.empty": "Aucun séjour disponible pour le moment.",
    "list.book": "Réserver",
    // BookingForm
    "form.allTrips": "Tous les séjours",
    "form.fullNotice": "Ce séjour est complet. Votre demande sera enregistrée en liste d'attente (sans paiement).",
    "form.choiceIntro": "Ce séjour est complet à l'hôtel {hotel}. Vous avez le choix :",
    "form.choiceWaitlistTitle": "Rejoindre la liste d'attente — Hôtel {hotel}",
    "form.choiceWaitlistDesc": "Aucun paiement. Nous vous contactons si une place se libère à l'hôtel principal.",
    "form.choiceSecondaryTitle": "Réserver à l'Hôtel {hotel} — places disponibles",
    "form.choiceSecondaryDesc": "Réservation confirmée avec paiement, hébergement à l'hôtel {hotel}.",
    "form.roomSection": "1. Type de chambre",
    "form.soldOut": "Complet",
    "form.perPerson": "/ pers",
    "form.contactSection": "2. Vos coordonnées",
    "form.firstName": "Prénom",
    "form.lastName": "Nom",
    "form.email": "E-mail",
    "form.phone": "Téléphone",
    "form.address": "Adresse",
    "form.addressPlaceholder": "N° et rue",
    "form.postalCode": "Code postal",
    "form.city": "Ville",
    "form.country": "Pays",
    "form.countryPlaceholder": "Sélectionnez votre pays",
    "form.nonEuNotice": "Pays de facturation hors zone euro (€) : des frais de {pct}% s'appliquent à votre réservation.",
    "form.participantsSection": "3. Participants ({n})",
    "form.selectRoomFirst": "Sélectionnez d'abord un type de chambre.",
    "form.roomHolds": "La chambre {room} accueille {n} personne(s). Merci de renseigner chaque participant.",
    "form.participantYou": "Participant 1 = vous (repris de vos coordonnées).",
    "form.firstNameParticipant": "Prénom * (participant {n})",
    "form.child": "Enfant -12 ans",
    "form.singleRate": "tarif single",
    "form.suiteOptsIntro": "Options pour la chambre (s'appliquent à l'ensemble des occupants) :",
    "form.accessibilitySection": "Accessibilité",
    "form.pmr": "Chambre PMR (accès handicapé) souhaitée",
    "form.wheelchair": "Se déplace en fauteuil roulant",
    "form.parkingSection": "4. Parking",
    "form.parking": "Parking",
    "form.perVehicle": "/ véhicule",
    "form.paymentSection": "5. Mode de paiement",
    "form.splitIntro": "Vous réglez une partie en Chèques Vacances et le solde avec un autre moyen.",
    "form.ancvAmount": "Montant en Chèques Vacances (€)",
    "form.balancePaidBy": "Solde réglé par",
    "form.balanceInfo": "Solde à régler : {amount}",
    "form.balanceInfoCb": " par carte bancaire (lien sécurisé après validation).",
    "form.balanceInfoDot": ".",
    "form.ficmssSection": "Avez-vous déjà participé au FICMSS ? *",
    "form.ficmssNo": "Non, c'est la première fois !",
    "form.ficmssYes": "Oui, je suis un(e) habitué(e) !",
    "form.noteSection": "6. Remarque (facultatif)",
    "form.notePlaceholder": "Une information à nous communiquer ?",
    "form.recap": "Récapitulatif",
    "form.recapChildren": "dont enfant(s) -12 ans × {n}",
    "form.recapArrival": "+ Arrivée la veille × {n}",
    "form.recapDeparture": "+ Départ le lendemain × {n}",
    "form.recapParking": "+ Parking × {n}",
    "form.recapFees": "+ Frais selon le pays ({pct}%)",
    "form.recapTotal": "Total TTC",
    "form.recapSelectRoom": "Sélectionnez un type de chambre.",
    "form.sending": "Envoi…",
    "form.btnWaitlist": "Rejoindre la liste d'attente",
    "form.btnPay": "Confirmer et payer la réservation",
    "form.btnConfirm": "Confirmer la réservation",
    "form.noPayment": "Aucun paiement ne sera demandé.",
    "form.cgvPrefix": "J'ai lu et j'accepte les ",
    "form.cgvLink": "Conditions Générales de Vente",
    // BookingForm confirmation
    "form.wlTitle": "Inscription en liste d'attente",
    "form.wlBody": "Le séjour est complet. Vous êtes inscrit en liste d'attente — aucun paiement n'est requis pour le moment. Nous vous contacterons si une place se libère.",
    "form.okTitle": "Réservation confirmée !",
    "form.okBody": "Un e-mail de confirmation vous sera envoyé. Les instructions de paiement ({method}) suivront.",
    // BookingForm toasts
    "toast.chooseRoom": "Choisissez un type de chambre.",
    "toast.contactReq": "Renseignez toutes vos coordonnées (prénom, nom, e-mail, téléphone).",
    "toast.addressReq": "Renseignez votre adresse postale complète (adresse, code postal, ville, pays).",
    "toast.participantsReq": "Complétez le prénom et le nom de chaque participant.",
    "toast.ficmssReq": "Merci d'indiquer si vous avez déjà participé au FICMSS.",
    "toast.ancvReq": "Indiquez le montant réglé en Chèques Vacances.",
    "toast.ancvTooHigh": "Le montant en Chèques Vacances doit être inférieur au total.",
    "toast.resError": "Erreur lors de la réservation.",
    "toast.cgvReq": "Merci de lire et d'accepter les Conditions Générales de Vente.",
    "toast.resCreatedMail": "Réservation créée. Le lien de paiement vous a été envoyé par e-mail.",
    // WaitlistValidate
    "wl.invalidTitle": "Lien invalide",
    "wl.invalidBody": "Ce lien de validation n'est pas valide. Contactez-nous si vous pensez qu'il s'agit d'une erreur.",
    "wl.confirmedTitle": "Inscription validée !",
    "wl.confirmedBody": "Votre réservation est confirmée. Un e-mail de confirmation vous a été envoyé.",
    "wl.refusedTitle": "Place refusée",
    "wl.refusedBody": "Votre réservation n° {no} a été annulée. La place sera proposée à la personne suivante en liste d'attente. Merci de nous avoir prévenus !",
    "wl.usedTitle": "Déjà validée",
    "wl.usedBody": "Votre réservation n° {no} est déjà confirmée.",
    "wl.expiredTitle": "Lien expiré",
    "wl.expiredBody": "Le délai pour valider cette place est dépassé. Contactez-nous si vous souhaitez toujours réserver — vous restez en liste d'attente.",
    "wl.banner": "Bonne nouvelle : une place s'est libérée ! Validez votre inscription ci-dessous en choisissant votre mode de paiement.",
    "wl.reservation": "Réservation",
    "wl.room": "Chambre",
    "wl.persons": "pers.",
    "wl.participants": "Participants",
    "wl.options": "Options",
    "wl.choosePayment": "Choisissez votre mode de paiement",
    "wl.validating": "Validation…",
    "wl.validate": "Valider mon inscription",
    "wl.refuseLink": "Je ne suis plus intéressé(e) — refuser la place",
    "wl.refuseTitle": "Refuser la place proposée ?",
    "wl.refuseDesc": "Votre réservation n° {no} sera annulée et la place proposée à la personne suivante en liste d'attente. Cette action est définitive.",
    "wl.refuseCancel": "Revenir",
    "wl.refusing": "Traitement…",
    "wl.refuseConfirm": "Oui, refuser la place",
    "wl.refuseError": "Erreur lors du refus.",
    "wl.confirmError": "Erreur lors de la validation.",
    "wl.confirmedMail": "Réservation confirmée. Le lien de paiement vous a été envoyé par e-mail.",
  },
  en: {
    "layout.subtitle": "Book your stay",
    "lang.fr": "FR",
    "lang.en": "EN",
    "lang.aria": "Choose language",
    "common.loading": "Loading…",
    "common.total": "Total amount",
    "common.reservationNo": "Booking number",
    "common.backToTrips": "Back to stays",
    "common.seeTrips": "See stays",
    "pay.cb_1x": "Credit card (1x)",
    "pay.cb_3x": "Credit card (3x)",
    "pay.cheque": "Cheque",
    "pay.cheque_1x": "Cheque (1x)",
    "pay.cheque_nx": "Cheque (instalments)",
    "pay.virement": "Bank transfer",
    "pay.cheque_vacances": "Holiday vouchers (ANCV)",
    "list.title": "Our themed stays",
    "list.subtitle": "Choose your stay and book in just a few clicks.",
    "list.empty": "No stays available at the moment.",
    "list.book": "Book",
    "form.allTrips": "All stays",
    "form.fullNotice": "This stay is fully booked. Your request will be added to the waiting list (no payment).",
    "form.choiceIntro": "This stay is fully booked at the {hotel} hotel. You have a choice:",
    "form.choiceWaitlistTitle": "Join the waiting list — {hotel} hotel",
    "form.choiceWaitlistDesc": "No payment. We will contact you if a spot opens up at the main hotel.",
    "form.choiceSecondaryTitle": "Book at the {hotel} hotel — spots available",
    "form.choiceSecondaryDesc": "Confirmed booking with payment, accommodation at the {hotel} hotel.",
    "form.roomSection": "1. Room type",
    "form.soldOut": "Sold out",
    "form.perPerson": "/ person",
    "form.contactSection": "2. Your details",
    "form.firstName": "First name",
    "form.lastName": "Last name",
    "form.email": "Email",
    "form.phone": "Phone",
    "form.address": "Address",
    "form.addressPlaceholder": "Street and number",
    "form.postalCode": "Postal code",
    "form.city": "City",
    "form.country": "Country",
    "form.countryPlaceholder": "Select your country",
    "form.nonEuNotice": "Billing country outside the euro (€) area: a {pct}% surcharge applies to your booking.",
    "form.participantsSection": "3. Participants ({n})",
    "form.selectRoomFirst": "Please select a room type first.",
    "form.roomHolds": "The {room} room accommodates {n} guest(s). Please fill in each participant.",
    "form.participantYou": "Participant 1 = you (taken from your details).",
    "form.firstNameParticipant": "First name * (participant {n})",
    "form.child": "Child under 12",
    "form.singleRate": "single rate",
    "form.suiteOptsIntro": "Room options (apply to all occupants):",
    "form.accessibilitySection": "Accessibility",
    "form.pmr": "Accessible room (disabled access) requested",
    "form.wheelchair": "Wheelchair user",
    "form.parkingSection": "4. Parking",
    "form.parking": "Parking",
    "form.perVehicle": "/ vehicle",
    "form.paymentSection": "5. Payment method",
    "form.splitIntro": "You pay part with holiday vouchers and the balance by another method.",
    "form.ancvAmount": "Amount in holiday vouchers (€)",
    "form.balancePaidBy": "Balance paid by",
    "form.balanceInfo": "Balance to pay: {amount}",
    "form.balanceInfoCb": " by credit card (secure link after validation).",
    "form.balanceInfoDot": ".",
    "form.ficmssSection": "Have you attended FICMSS before? *",
    "form.ficmssNo": "No, it's my first time!",
    "form.ficmssYes": "Yes, I'm a regular!",
    "form.noteSection": "6. Note (optional)",
    "form.notePlaceholder": "Anything you'd like to tell us?",
    "form.recap": "Summary",
    "form.recapChildren": "incl. child(ren) under 12 × {n}",
    "form.recapArrival": "+ Arrival the day before × {n}",
    "form.recapDeparture": "+ Departure the day after × {n}",
    "form.recapParking": "+ Parking × {n}",
    "form.recapFees": "+ Country surcharge ({pct}%)",
    "form.recapTotal": "Total (incl. tax)",
    "form.recapSelectRoom": "Select a room type.",
    "form.sending": "Sending…",
    "form.btnWaitlist": "Join the waiting list",
    "form.btnPay": "Confirm and pay for the booking",
    "form.btnConfirm": "Confirm the booking",
    "form.noPayment": "No payment will be requested.",
    "form.cgvPrefix": "I have read and accept the ",
    "form.cgvLink": "Terms and Conditions of Sale",
    "form.wlTitle": "Added to the waiting list",
    "form.wlBody": "The stay is fully booked. You are on the waiting list — no payment is required for now. We will contact you if a spot opens up.",
    "form.okTitle": "Booking confirmed!",
    "form.okBody": "A confirmation email will be sent to you. Payment instructions ({method}) will follow.",
    "toast.chooseRoom": "Please select a room type.",
    "toast.contactReq": "Please fill in all your details (first name, last name, email, phone).",
    "toast.addressReq": "Please fill in your full postal address (address, postal code, city, country).",
    "toast.participantsReq": "Please complete the first and last name of each participant.",
    "toast.ficmssReq": "Please indicate whether you have attended FICMSS before.",
    "toast.ancvReq": "Please enter the amount paid with holiday vouchers.",
    "toast.ancvTooHigh": "The holiday vouchers amount must be lower than the total.",
    "toast.resError": "An error occurred during booking.",
    "toast.cgvReq": "Please read and accept the Terms and Conditions of Sale.",
    "toast.resCreatedMail": "Booking created. The payment link has been sent to you by email.",
    "wl.invalidTitle": "Invalid link",
    "wl.invalidBody": "This validation link is not valid. Contact us if you believe this is a mistake.",
    "wl.confirmedTitle": "Booking validated!",
    "wl.confirmedBody": "Your booking is confirmed. A confirmation email has been sent to you.",
    "wl.refusedTitle": "Spot declined",
    "wl.refusedBody": "Your booking no. {no} has been cancelled. The spot will be offered to the next person on the waiting list. Thank you for letting us know!",
    "wl.usedTitle": "Already validated",
    "wl.usedBody": "Your booking no. {no} is already confirmed.",
    "wl.expiredTitle": "Link expired",
    "wl.expiredBody": "The deadline to validate this spot has passed. Contact us if you still wish to book — you remain on the waiting list.",
    "wl.banner": "Good news: a spot has opened up! Validate your booking below by choosing your payment method.",
    "wl.reservation": "Booking",
    "wl.room": "Room",
    "wl.persons": "guests",
    "wl.participants": "Participants",
    "wl.options": "Options",
    "wl.choosePayment": "Choose your payment method",
    "wl.validating": "Validating…",
    "wl.validate": "Validate my booking",
    "wl.refuseLink": "I'm no longer interested — decline the spot",
    "wl.refuseTitle": "Decline the offered spot?",
    "wl.refuseDesc": "Your booking no. {no} will be cancelled and the spot offered to the next person on the waiting list. This action is final.",
    "wl.refuseCancel": "Go back",
    "wl.refusing": "Processing…",
    "wl.refuseConfirm": "Yes, decline the spot",
    "wl.refuseError": "An error occurred while declining.",
    "wl.confirmError": "An error occurred during validation.",
    "wl.confirmedMail": "Booking confirmed. The payment link has been sent to you by email.",
  },
};

const KEY = "public_lang";
const EVT = "publiclangchange";

function getLang() {
  if (typeof window === "undefined") return "fr";
  return window.__publicLang || window.localStorage.getItem(KEY) || "fr";
}
function setLangGlobal(l) {
  window.__publicLang = l;
  try { window.localStorage.setItem(KEY, l); } catch (e) { /* ignore */ }
  window.dispatchEvent(new CustomEvent(EVT, { detail: l }));
}

function translate(lang, key, vars) {
  let s = (DICT[lang] && DICT[lang][key]) ?? DICT.fr[key] ?? key;
  if (vars) for (const k of Object.keys(vars)) s = s.replaceAll(`{${k}}`, String(vars[k]));
  return s;
}

// Provider conservé comme passe-plat (l'état est global via window, robuste au code-splitting).
export function PublicLangProvider({ children }) {
  return children;
}

export function useLang() {
  const [lang, setL] = useState(getLang);
  useEffect(() => {
    const h = () => setL(getLang());
    window.addEventListener(EVT, h);
    // resync au montage (au cas où une autre instance a déjà changé la langue)
    setL(getLang());
    return () => window.removeEventListener(EVT, h);
  }, []);
  const t = useCallback((key, vars) => translate(lang, key, vars), [lang]);
  return { lang, setLang: setLangGlobal, t };
}

export function LangSwitch() {
  const { lang, setLang, t } = useLang();
  const opts = [
    { code: "fr", short: "FR", flag: "🇫🇷" },
    { code: "en", short: "EN", flag: "🇬🇧" },
  ];
  return (
    <div className="flex items-center rounded-full border border-white/25 bg-white/10 p-0.5" role="group" aria-label={t("lang.aria")} data-testid="public-lang-switch">
      {opts.map((o) => (
        <button
          key={o.code}
          type="button"
          data-testid={`lang-${o.code}`}
          aria-pressed={lang === o.code}
          onClick={() => setLang(o.code)}
          className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${lang === o.code ? "bg-white text-slate-900" : "text-white/80 hover:text-white"}`}
        >
          <span className="mr-1">{o.flag}</span>{o.short}
        </button>
      ))}
    </div>
  );
}
